import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff, Storage, Settings, Language, CloudQueue, AccountCircle, Lock, VpnKey, Email } from "@material-ui/icons";
import React from "react";
import styled, { keyframes } from "styled-components";

function TabAribaCatalog({ values, touched, errors, handleChange, setFieldValue }) {
    const [passwordVisibility, setPasswordVisibility] = React.useState({
        passwordCatalog: false,
    });

    const togglePasswordVisibility = (field) => {
        setPasswordVisibility((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    // defaults visuais (não mexe no form state se já tiver valores)
    const ensureDefault = (name, def) =>
        values[name] === undefined || values[name] === null || values[name] === ""
            ? def
            : values[name];

    return (
        <ModernFormContainer>
            <SectionCard>
                <SectionHeader>
                    <SectionIcon color="#667eea">
                        <Settings />
                    </SectionIcon>
                    <SectionTitle>Parâmetros SOAP (Parameters)</SectionTitle>
                </SectionHeader>
                <FormGrid columns={3}>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <CloudQueue style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
                            Realm
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="realm"
                            name="realm"
                            placeholder="ex.: 745602309-T"
                            value={ensureDefault("realm", "")}
                            onChange={handleChange}
                            error={touched.realm && Boolean(errors.realm)}
                            helperText={touched.realm && errors.realm}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Settings style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
                            Solution
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="Solution"
                            name="Solution"
                            placeholder="BuyerCatalog"
                            value={ensureDefault("Solution", "BuyerCatalog")}
                            onChange={handleChange}
                            error={touched.Solution && Boolean(errors.Solution)}
                            helperText={touched.Solution && errors.Solution}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Settings style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
                            Variant
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="Variant"
                            name="Variant"
                            placeholder="ex.: VREALM_352173"
                            value={ensureDefault("Variant", "")}
                            onChange={handleChange}
                            error={touched.Variant && Boolean(errors.Variant)}
                            helperText={touched.Variant && errors.Variant}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Storage style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
                            Partition
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="Partition"
                            name="Partition"
                            placeholder="ex.: PREALM_352173"
                            value={ensureDefault("Partition", "")}
                            onChange={handleChange}
                            error={touched.Partition && Boolean(errors.Partition)}
                            helperText={touched.Partition && errors.Partition}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Language style={{ fontSize: '18px', marginRight: '8px', color: '#8e44ad' }} />
                            URL Catalog
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="soapUrl"
                            name="soapUrl"
                            placeholder="https://<host>/.../CatalogService"
                            value={ensureDefault("soapUrl", "")}
                            onChange={handleChange}
                            error={touched.soapUrl && Boolean(errors.soapUrl)}
                            helperText={touched.soapUrl && errors.soapUrl}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#e67e22' }} />
                            SubscriptionName
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="SubscriptionName"
                            name="SubscriptionName"
                            placeholder="ex.: Teste 4"
                            value={ensureDefault("SubscriptionName", "")}
                            onChange={handleChange}
                            error={touched.SubscriptionName && Boolean(errors.SubscriptionName)}
                            helperText={touched.SubscriptionName && errors.SubscriptionName}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Settings style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />
                            LoadMode (F/I)
                        </FieldLabel>
                        <TextField
                            select
                            SelectProps={{ native: true }}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="loadMode"
                            name="loadMode"
                            value={ensureDefault("loadMode", "F")}
                            onChange={handleChange}
                            error={touched.loadMode && Boolean(errors.loadMode)}
                            helperText={touched.loadMode && errors.loadMode}
                            variant="outlined"
                        >
                            <option value="F">F (Full)</option>
                            <option value="I">I (Incremental)</option>
                        </TextField>
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#16a085' }} />
                            SystemId
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="systemId"
                            name="systemId"
                            placeholder="ex.: ESAGPQAS"
                            value={ensureDefault("systemId", "")}
                            onChange={handleChange}
                            error={touched.systemId && Boolean(errors.systemId)}
                            helperText={touched.systemId && errors.systemId}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#2980b9' }} />
                            ANSupplierID
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="ANSupplierID"
                            name="ANSupplierID"
                            placeholder="ex.: AN11238381897-T"
                            value={ensureDefault("ANSupplierID", values.identityFrom || "")}
                            onChange={handleChange}
                            error={touched.ANSupplierID && Boolean(errors.ANSupplierID)}
                            helperText={touched.ANSupplierID && errors.ANSupplierID}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Storage style={{ fontSize: '18px', marginRight: '8px', color: '#c0392b' }} />
                            Attachment contentID (opcional)
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="contentID"
                            name="contentID"
                            placeholder="ex.: cid:FOL184EXT97800000000978"
                            value={ensureDefault("contentID", "")}
                            onChange={handleChange}
                            error={touched.contentID && Boolean(errors.contentID)}
                            helperText={touched.contentID && errors.contentID}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>
                </FormGrid>

                <CheckboxRow>
                    <CheckboxContainer>
                        <Checkbox
                            color="primary"
                            checked={ensureDefault("MultiSupplierCIF", true) === true}
                            onChange={(e) => setFieldValue("MultiSupplierCIF", e.target.checked)}
                        />
                        <CheckboxLabel>MultiSupplierCIF</CheckboxLabel>
                    </CheckboxContainer>

                    <CheckboxContainer>
                        <Checkbox
                            color="primary"
                            checked={ensureDefault("ByPassApproval", true) === true}
                            onChange={(e) => setFieldValue("ByPassApproval", e.target.checked)}
                        />
                        <CheckboxLabel>ByPassApproval</CheckboxLabel>
                    </CheckboxContainer>

                    <CheckboxContainer>
                        <Checkbox
                            color="primary"
                            checked={ensureDefault("autoPublish", true) === true}
                            onChange={(e) => setFieldValue("autoPublish", e.target.checked)}
                        />
                        <CheckboxLabel>AutoPublish</CheckboxLabel>
                    </CheckboxContainer>
                </CheckboxRow>
            </SectionCard>

            <SectionCard hidden={!values.id}>
                <SectionHeader>
                    <SectionIcon color="#3498db">
                        <Language />
                    </SectionIcon>
                    <SectionTitle>Parâmetros cXML / CIF</SectionTitle>
                </SectionHeader>
                <FormGrid columns={3}>
                    <StyledFieldContainer>
                        <FieldLabel>
                            <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
                            Identity From (Fornecedor)
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="identityFrom"
                            name="identityFrom"
                            placeholder="ex.: AN11232820244-T"
                            value={ensureDefault("identityFrom", "")}
                            onChange={handleChange}
                            error={touched.identityFrom && Boolean(errors.identityFrom)}
                            helperText={touched.identityFrom && errors.identityFrom}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
                            Identity To (Comprador)
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="identityTo"
                            name="identityTo"
                            placeholder="ex.: AN11212940243-T"
                            value={ensureDefault("identityTo", "")}
                            onChange={handleChange}
                            error={touched.identityTo && Boolean(errors.identityTo)}
                            helperText={touched.identityTo && errors.identityTo}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
                            Identity Sender
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="identitySender"
                            name="identitySender"
                            placeholder="ex.: AN11232820244-T"
                            value={ensureDefault("identitySender", "")}
                            onChange={handleChange}
                            error={touched.identitySender && Boolean(errors.identitySender)}
                            helperText={touched.identitySender && errors.identitySender}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
                            Shared Secret (Network)
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="sharedSecretNetwork"
                            name="sharedSecretNetwork"
                            placeholder="Shared Secret"
                            value={ensureDefault("sharedSecretNetwork", values.ariba_secret || "")}
                            onChange={handleChange}
                            error={touched.sharedSecretNetwork && Boolean(errors.sharedSecretNetwork)}
                            helperText={touched.sharedSecretNetwork && errors.sharedSecretNetwork}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Email style={{ fontSize: '18px', marginRight: '8px', color: '#e67e22' }} />
                            E-mail de Notificação
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="email"
                            name="email"
                            placeholder="ex.: nome@empresa.com"
                            value={ensureDefault("email", "")}
                            onChange={handleChange}
                            error={touched.email && Boolean(errors.email)}
                            helperText={touched.email && errors.email}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Storage style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />
                            Catalog Name
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="catalogName"
                            name="catalogName"
                            placeholder="ex.: FornNew"
                            value={ensureDefault("catalogName", "")}
                            onChange={handleChange}
                            error={touched.catalogName && Boolean(errors.catalogName)}
                            helperText={touched.catalogName && errors.catalogName}
                            autoComplete="off"
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Language style={{ fontSize: '18px', marginRight: '8px', color: '#16a085' }} />
                            Idioma (xml:lang / CIF Language)
                        </FieldLabel>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id="languageDefault"
                            name="languageDefault"
                            placeholder="ex.: ptBR"
                            value={ensureDefault("languageDefault", "ptBR")}
                            onChange={handleChange}
                            error={touched.languageDefault && Boolean(errors.languageDefault)}
                            helperText={touched.languageDefault && errors.languageDefault}
                            variant="outlined"
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#2980b9' }} />
                            SUPPLIERID_DOMAIN (CIF)
                        </FieldLabel>
                        <TextField
                            fullWidth
                            id="supplierIdDomain"
                            name="supplierIdDomain"
                            placeholder="ex.: NETWORKID"
                            value={ensureDefault("supplierIdDomain", "NETWORKID")}
                            onChange={handleChange}
                            autoComplete="off"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                        />
                    </StyledFieldContainer>
                </FormGrid>
            </SectionCard>

            <SectionCard>
                <SectionHeader>
                    <SectionIcon color="#e74c3c">
                        <Lock />
                    </SectionIcon>
                    <SectionTitle>Endpoint & Auth</SectionTitle>
                </SectionHeader>
                <FormGrid columns={2}>
                    <StyledFieldContainer>
                        <FieldLabel>
                            <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
                            Basic Auth - Username
                        </FieldLabel>
                        <TextField
                            fullWidth
                            id="userNameCatalog"
                            name="userNameCatalog"
                            placeholder="Digite Username"
                            value={ensureDefault("userNameCatalog", "")}
                            onChange={handleChange}
                            autoComplete="off"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                        />
                    </StyledFieldContainer>

                    <StyledFieldContainer>
                        <FieldLabel>
                            <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />
                            Basic Auth - Password
                        </FieldLabel>
                        <TextField
                            fullWidth
                            id="passwordCatalog"
                            name="passwordCatalog"
                            placeholder="Digite password"
                            value={ensureDefault("passwordCatalog", "")}
                            onChange={handleChange}
                            autoComplete="off"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            type={passwordVisibility.passwordCatalog ? "text" : "password"}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => togglePasswordVisibility("passwordCatalog")}
                                            edge="end"
                                        >
                                            {passwordVisibility.passwordCatalog ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </StyledFieldContainer>
                </FormGrid>

                <InfoBox>
                    <InfoTitle>Informações Importantes:</InfoTitle>
                    <InfoText>• <strong>SOAP</strong>: estes campos alimentam o Body &lt;Parameters&gt; e o AttachmentFolder (contentID é opcional).</InfoText>
                    <InfoText>• <strong>Gerados no back-end</strong>: FileID, FileName, Total/CurrentFileCount e CreatedTimestamp.</InfoText>
                    <InfoText>• <strong>CIF</strong>: Supplier ID (identityFrom) continua sendo usado como AN do fornecedor; Language e SUPPLIERID_DOMAIN afetam o cabeçalho do CIF.</InfoText>
                </InfoBox>
            </SectionCard>
        </ModernFormContainer>
    );
}

export default TabAribaCatalog;

/* ===== Modern Styles ===== */

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }

  ${props => props.hidden && `
    display: none;
  `}
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.color ? `${props.color}15` : '#667eea15'};
  color: ${props => props.color || '#667eea'};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${SectionCard}:hover & {
    transform: scale(1.1);
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => {
    if (props.columns === 3) return 'repeat(3, 1fr)';
    if (props.columns === 2) return 'repeat(2, 1fr)';
    return '1fr';
  }};
  gap: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: ${props => props.columns === 3 ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)'};
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  .MuiInputLabel-outlined {
    font-family: 'Mulish', sans-serif;
    font-weight: 500;
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;

const CheckboxRow = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
  flex-wrap: wrap;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(102, 126, 234, 0.05);
  }
`;

const CheckboxLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  font-family: 'Mulish', sans-serif;
`;

const InfoBox = styled.div`
  margin-top: 20px;
  padding: 16px 20px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  border-left: 4px solid #667eea;
  border-radius: 8px;
`;

const InfoTitle = styled.h4`
  font-size: 15px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 12px 0;
  font-family: 'Mulish', sans-serif;
`;

const InfoText = styled.p`
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin: 6px 0;
  font-family: 'Mulish', sans-serif;
`;
